const FLAG_SRC: Record<string, string> = {
  PT: "/flags/pt.svg",
  ES: "/flags/es.svg",
  IT: "/flags/it.svg",
  GR: "/flags/gr.svg",
};

interface CountryFlagProps {
  iso: string;
  className?: string;
  alt?: string;
}

/** Renders a country flag image (works on Windows; emoji flags often show as PT/ES text). */
export function CountryFlag({
  iso,
  className = "h-7 w-10 rounded-sm object-cover border border-border/40 shadow-sm shrink-0",
  alt = "",
}: CountryFlagProps) {
  const code = iso.trim().toUpperCase();
  const src = FLAG_SRC[code];
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      width={40}
      height={28}
      loading="lazy"
      decoding="async"
    />
  );
}
